
import React, { useState } from "react"

export default function HotelBookingForm() {
  const [formData, setFormData] = useState({
    bookingType: "room", // room | banquet | lawn
    firstName: "",
    lastName: "",
    email: "",
    roomType: "",
    numberOfGuests: "",
    arrivalDate: "",
    arrivalTime: "",
    arrivalPeriod: "AM",
    departureMonth: "",
    departureDay: "",
    departureYear: "",
    eventDate: "",
    eventStartTime: "",
    eventEndTime: "",
    eventType: "",
    specialRequests: "",
  })

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    console.log("Form submitted:", formData)
    // Submit logic here
  }

  const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December",
  ]
  const days = Array.from({ length: 31 }, (_, i) => i + 1)
  const years = Array.from({ length: 10 }, (_, i) => new Date().getFullYear() + i)

  return (
    <div
      className="min-vh-100 w-100 position-relative"
      style={{
        background: "linear-gradient(135deg, #87CEEB 0%, #4682B4 100%)",
        fontFamily: "system-ui, -apple-system, sans-serif",
      }}
    >
      {/* Back Button - Top Left */}
      <button
        type="button"
        onClick={() => window.history.back()}
        className="btn btn-outline-secondary position-absolute"
        style={{
          top: "1rem",
          left: "1rem",
          borderRadius: "25px",
          fontWeight: "600",
          padding: "8px 20px",
          zIndex: 1000,
        }}
      >
        ← Back
      </button>

      <div className="w-100">
        <div className="row justify-content-center">
          <div className="col-12 col-lg-8 col-xl-6">
            <div className="card shadow-lg border-0" style={{ borderRadius: "20px" }}>
              <div className="card-body p-4 p-md-5">

                <div className="text-center mb-4">
                  <h1 className="fw-bold mb-2" style={{ color: "#2c3e50", fontSize: "2.5rem" }}>
                    Booking Request Form
                  </h1>
                  <p className="text-muted mb-4" style={{ fontSize: "1.1rem" }}>
                    Experience something new every moment
                  </p>
                </div>

                <form onSubmit={handleSubmit}>

                  {/* Booking Type */}
                  <div className="mb-3">
                    <label className="form-label fw-semibold text-dark">Booking Type</label>
                    <select
                      className="form-select form-select-lg"
                      name="bookingType"
                      value={formData.bookingType}
                      onChange={handleInputChange}
                      style={{ borderRadius: "10px", border: "2px solid #e9ecef" }}
                    >
                      <option value="room">Room</option>
                      <option value="banquet">Banquet Hall</option>
                      <option value="lawn">Lawn</option>
                    </select>
                  </div>

                  {/* Common Fields */}
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label className="form-label fw-semibold text-dark">First Name</label>
                      <input
                        type="text"
                        className="form-control form-control-lg"
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleInputChange}
                        style={{ borderRadius: "10px", border: "2px solid #e9ecef" }}
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label fw-semibold text-dark">Last Name</label>
                      <input
                        type="text"
                        className="form-control form-control-lg"
                        name="lastName"
                        value={formData.lastName}
                        onChange={handleInputChange}
                        style={{ borderRadius: "10px", border: "2px solid #e9ecef" }}
                      />
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label fw-semibold text-dark">E-mail</label>
                    <input
                      type="email"
                      className="form-control form-control-lg"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      placeholder="example@example.com"
                      style={{ borderRadius: "10px", border: "2px solid #e9ecef" }}
                    />
                  </div>

                  {/* Room Fields */}
                  {formData.bookingType === "room" && (
                    <>
                      <div className="row mb-3">
                        <div className="col-md-6">
                          <label className="form-label fw-semibold text-dark">Room Type</label>
                          <select
                            className="form-select form-select-lg"
                            name="roomType"
                            value={formData.roomType}
                            onChange={handleInputChange}
                            style={{ borderRadius: "10px", border: "2px solid #e9ecef" }}
                          >
                            <option value="">Select</option>
                            <option value="standard">Standard</option>
                            <option value="deluxe">Deluxe</option>
                            <option value="suite">Suite</option>
                          </select>
                        </div>
                        <div className="col-md-6">
                          <label className="form-label fw-semibold text-dark">Number of Guests</label>
                          <input
                            type="number"
                            className="form-control form-control-lg"
                            name="numberOfGuests"
                            value={formData.numberOfGuests}
                            onChange={handleInputChange}
                            min="1"
                            style={{ borderRadius: "10px", border: "2px solid #e9ecef" }}
                          />
                        </div>
                      </div>

                      <div className="row mb-3">
                        <div className="col-md-6">
                          <label className="form-label fw-semibold text-dark">Arrival Date</label>
                          <input
                            type="date"
                            className="form-control form-control-lg"
                            name="arrivalDate"
                            value={formData.arrivalDate}
                            onChange={handleInputChange}
                            style={{ borderRadius: "10px", border: "2px solid #e9ecef" }}
                          />
                        </div>
                        <div className="col-md-6">
                          <label className="form-label fw-semibold text-dark">Arrival Time</label>
                          <input
                            type="time"
                            className="form-control form-control-lg"
                            name="arrivalTime"
                            value={formData.arrivalTime}
                            onChange={handleInputChange}
                            style={{ borderRadius: "10px", border: "2px solid #e9ecef" }}
                          />
                        </div>
                      </div>

                      <div className="row mb-3">
                        <div className="col-md-4">
                          <label className="form-label fw-semibold text-dark">Departure Month</label>
                          <select
                            className="form-select"
                            name="departureMonth"
                            value={formData.departureMonth}
                            onChange={handleInputChange}
                          >
                            <option value="">Select</option>
                            {months.map((m, i) => (
                              <option key={i} value={m}>{m}</option>
                            ))}
                          </select>
                        </div>
                        <div className="col-md-4">
                          <label className="form-label fw-semibold text-dark">Departure Day</label>
                          <select
                            className="form-select"
                            name="departureDay"
                            value={formData.departureDay}
                            onChange={handleInputChange}
                          >
                            <option value="">Select</option>
                            {days.map((d) => (
                              <option key={d} value={d}>{d}</option>
                            ))}
                          </select>
                        </div>
                        <div className="col-md-4">
                          <label className="form-label fw-semibold text-dark">Departure Year</label>
                          <select
                            className="form-select"
                            name="departureYear"
                            value={formData.departureYear}
                            onChange={handleInputChange}
                          >
                            <option value="">Select</option>
                            {years.map((y) => (
                              <option key={y} value={y}>{y}</option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </>
                  )}

                  {/* Banquet/Lawn Fields */}
                  {(formData.bookingType === "banquet" || formData.bookingType === "lawn") && (
                    <>
                      <div className="row mb-3">
                        <div className="col-md-6">
                          <label className="form-label fw-semibold text-dark">Event Date</label>
                          <input
                            type="date"
                            className="form-control"
                            name="eventDate"
                            value={formData.eventDate}
                            onChange={handleInputChange}
                          />
                        </div>
                        <div className="col-md-3">
                          <label className="form-label fw-semibold text-dark">Start Time</label>
                          <input
                            type="time"
                            className="form-control"
                            name="eventStartTime"
                            value={formData.eventStartTime}
                            onChange={handleInputChange}
                          />
                        </div>
                        <div className="col-md-3">
                          <label className="form-label fw-semibold text-dark">End Time</label>
                          <input
                            type="time"
                            className="form-control"
                            name="eventEndTime"
                            value={formData.eventEndTime}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="mb-3">
                        <label className="form-label fw-semibold text-dark">Event Type</label>
                        <input
                          type="text"
                          className="form-control"
                          name="eventType"
                          value={formData.eventType}
                          onChange={handleInputChange}
                          placeholder="Wedding, Party, Conference, etc."
                        />
                      </div>
                    </>
                  )}

                  {/* Special Requests */}
                  <div className="mb-4">
                    <label className="form-label fw-semibold text-dark">Special Requests</label>
                    <textarea
                      className="form-control"
                      name="specialRequests"
                      value={formData.specialRequests}
                      onChange={handleInputChange}
                      rows={4}
                      style={{ borderRadius: "10px", border: "2px solid #e9ecef" }}
                    ></textarea>
                  </div>

                  <div className="text-center">
                    <button
                      type="submit"
                      className="btn btn-lg px-5 py-3 fw-semibold"
                      style={{
                        backgroundColor: "#28a745",
                        borderColor: "#28a745",
                        color: "white",
                        borderRadius: "25px",
                        fontSize: "1.2rem",
                        minWidth: "200px",
                      }}
                    >
                      Submit
                    </button>
                  </div>

                </form>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
